export default "__VITE_ASSET__$QHH4PBr__"